import type { ResumeData } from "@stylingcv/schema";
import { defaultResumeData } from "@stylingcv/schema";
import type { AxiosResponse } from "axios";

import { axios } from "@/client/libs/axios";

// Ensures basic required structure exists before sending to API
const sanitizeForValidation = (data: ResumeData): ResumeData => {
  // Start with complete default resume data
  const sanitizedData = structuredClone(defaultResumeData);

  // Merge with provided data if it exists
  if (data) {
    // Merge top-level properties
    Object.assign(sanitizedData, data);

    // Merge nested objects with proper fallbacks
    if (data.basics) {
      Object.assign(sanitizedData.basics, data.basics);
    }

    if (data.sections) {
      Object.assign(sanitizedData.sections, data.sections);
    }

    if (data.metadata) {
      Object.assign(sanitizedData.metadata, data.metadata);
    }
  }

  return sanitizedData;
};

export const validateGuestResume = async (resumeData: ResumeData) => {
  try {
    // Sanitize data before sending to API
    const sanitizedData = sanitizeForValidation(resumeData);

    // Send to validation endpoint
    const response = await axios.patch<
      { success: boolean; message: string; data: ResumeData },
      AxiosResponse<{ success: boolean; message: string; data: ResumeData }>,
      ResumeData
    >("/resume/guest-resume", sanitizedData);

    return response.data;
  } catch (error) {
    console.error("Error validating guest resume:", error);
    throw error;
  }
};
